import React, { useEffect, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import { MapContainer, MapConsumer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';    
import { getVar } from './Helper';
import styled from 'styled-components';

const PopupImage = styled(Link)`
    height: 120px;
    width: 222px;
    background-position-x: center !important;
    background-position-y: center !important;
    background-size: cover !important;
    background-image : url(${props => props.bg});
    background-repeat: no-repeat;    
    border:none;
    position: absolute;
    top: 0;
    left: 0;
    border-top-left-radius:4px;  
    border-top-right-radius:4px;  
`;
const PopupLocation = styled.span`
    display:block;
    font-size: 10px;
    color: #8f8f8f;
`;
const PopupTitle = styled(Link)`
    width: 200px;
    display: inline-block;
    padding-right: 15px;
    padding-bottom: 5px;
`;

function MapInnerWrap ( { plots, map } ){

    const tileUrl = getVar().tileUrl;    
    let history = useHistory();    
    const recenter = useCallback((evt)=>{     
        map.flyTo(evt.latlng);
    },[map])

    return (<React.Fragment>
        <TileLayer url={tileUrl}/>
            {plots.map((plot)=>{                
                return (
                    <Marker eventHandlers={{
                            click: (e) => {recenter(e)}
                        }} 
                      key={plot.id} position={[plot.latitude, plot.longitude]}>                 
                    <Popup>
                        {plot.imageSrc ? (
                            <PopupImage to={`${history.location.pathname}?plot=${plot.id}`}
                                bg={getVar().baseUrl + plot.imageSrc}  /> 
                        ) : null}                       
                        <div>
                            <PopupTitle to={`${history.location.pathname}?plot=${plot.id}`}>{plot.name}</PopupTitle>
                            <PopupLocation>{`${plot.region}, ${plot.country}`}</PopupLocation>
                        </div>                        
                    </Popup>
                    </Marker>
                )
            })}   
    </React.Fragment>)
}

function Map ( {plots} ) {  
    const center = [5.505, -18.59];     
    
    let zoom = 2.25; 

    if(window.visualViewport.width >= 3840){
        zoom = 3.75;
    }else if(window.visualViewport.width >= 1920){
        zoom = 2.75;
    }else if(window.visualViewport.width >= 1366){
        zoom = 2.25;
    }else if(window.visualViewport.width >= 1024){
        zoom = 2.0;
    }
    
    useEffect(()=>{
        let DefaultIcon = L.icon({
            iconUrl: getVar().markerIcon,
            shadowUrl: getVar().markerShadow
        });
        L.Marker.prototype.options.icon = DefaultIcon;          
    },[])

    return (
        <MapContainer className="map" center={center} zoom={zoom} zoomSnap="0.25" scrollWheelZoom={false} tap={false} >
            <MapConsumer>
                {(map) => {
                    return ( <MapInnerWrap map={map} plots={plots} />)
                }}                
            </MapConsumer>           
        </MapContainer>
    )
}

export default Map;